/*
 * Envision customizations
 * assets/bundle-builder.js
 *
 * Bundle Builder JavaScript
 */


/**
 * Bundle Builder banners
 */
(function() {
  const isBundleBuilder = window.location.href.includes("apps/bundles/");
  if (isBundleBuilder) {
    const bannersHTML = `
      <div class="bundle-builder__header mb-5">
        <div class="burgundy-banner">
          <div class="collection-banner flex flex-col md:flex-row items-center text-center gap-y-6">
            <div class="collection-banner__content w-full items-center text-center">
              <div class="block">
                <h1 class="collection-banner__heading mb-0 inline">
                  bundle & save
                </h1>
              </div>
              <div class="rte mt-4">
                <p>Beautifully packed gift set with 3 or more spices.<br />Add a gift note in the cart.</p>
              </div>
            </div>
          </div>
        </div>

        <div class="bundle-builder__banner">
          <div>
            <div class="bundle-builder__banner-content">
              <p>Sets are packed in 3 or 6-jar gift boxes.<br />Extra jars will be packed separately.<br />Want certain jars packed together? Just start a new bundle!</p>
              <div class="bundle-builder__banner-content__sets">
                <figure class="bundle-builder__banner-content__set">
                  <div class="bundle-builder__banner-content__set-image">
                    <img class="bundle-builder__banner-content__set-of-3" src="https://cdn.shopify.com/s/files/1/2554/1458/files/3_Spices.svg?v=1689866171" alt="3-Spices Gift Set" />
                  </div>
                  <figcaption class="bundle-builder__banner-content__set-title">3+ Spices</figcaption>
                  <div class="bundle-builder__banner-content__set-savings">Save $1</div>
                </figure>
                <div class="bundle-builder__banner-content__other-sets">
                  <p class="bundle-builder__banner-content__other-sets__free-shipping">Free shipping in the U.S.!</p>
                  <figure class="bundle-builder__banner-content__set">
                    <div class="bundle-builder__banner-content__set-image">
                      <img class="bundle-builder__banner-content__set-of-6" src="https://cdn.shopify.com/s/files/1/2554/1458/files/6_Spices.svg?v=1689866588" alt="6-Spices Gift Set" />
                    </div>
                    <figcaption class="bundle-builder__banner-content__set-title">6+ Spices</figcaption>
                    <div class="bundle-builder__banner-content__set-savings">Save $3</div>
                  </figure>
                  <figure class="bundle-builder__banner-content__set">
                    <div class="bundle-builder__banner-content__set-image">
                      <img class="bundle-builder__banner-content__set-of-9" src="https://cdn.shopify.com/s/files/1/2554/1458/files/9_Spices.svg?v=1689866588" alt="9-Spices Gift Set" />
                    </div>
                    <figcaption class="bundle-builder__banner-content__set-title">9+ Spices</figcaption>
                    <div class="bundle-builder__banner-content__set-savings">Save $5</div>
                  </figure>
                  <figure class="bundle-builder__banner-content__set">
                    <div class="bundle-builder__banner-content__set-image">
                      <img class="bundle-builder__banner-content__set-of-12" src="https://cdn.shopify.com/s/files/1/2554/1458/files/12_Spices.svg?v=1689866589" alt="12-Spices Gift Set" />
                    </div>
                    <figcaption class="bundle-builder__banner-content__set-title">12+ Spices</figcaption>
                    <div class="bundle-builder__banner-content__set-savings">Save $8</div>
                  </figure>
                </div>
              </div>
              <a class="bundle-builder__banner-content__best-selling-link" href="/collections/gifts?utm_campaign=GiftSet&utm_source=BundleBuilder&utm_medium=Link">
                <figure class="bundle-builder__banner-content__best-selling">
                  <div class="bundle-builder__banner-content__best-selling-image">
                    <img src="https://cdn.shopify.com/s/files/1/2554/1458/files/Bestsellers_icon_53654e4a-0060-4427-a562-b9e5e628849c.svg?v=1689867657" alt="Illustration of a Gift" />
                  </div>
                  <figcaption><span>Check out our</span><span>bestselling gift sets</span></figcaption>
                </figure>
              </a>
            </div>
          </div>
        </div>
      </div>
    `
    var mainContent = document.getElementById('main-content');
    if (mainContent) {
      // Create a temporary container to parse the HTML string
      var tempDiv = document.createElement('div');
      tempDiv.innerHTML = bannersHTML;
      // Insert the banner as the first child of #MainContent
      if (mainContent.firstChild) {
        mainContent.insertBefore(tempDiv.firstElementChild, mainContent.firstChild);
      } else {
        mainContent.appendChild(tempDiv.firstElementChild);
      }
    }
    waitForElm("#main-content h1.bundle-builder-app--bundle--name").then(function (bundleBuilderOriginalTitle) {
      if (bundleBuilderOriginalTitle && bundleBuilderOriginalTitle.parentNode) {
        bundleBuilderOriginalTitle.parentNode.removeChild(bundleBuilderOriginalTitle);
      }
    });
    waitForElm("#main-content .bundle-builder-app--bundle--description ").then(function (bundleBuilderOriginalDescription) {
      if (bundleBuilderOriginalDescription && bundleBuilderOriginalDescription.parentNode) {
        bundleBuilderOriginalDescription.parentNode.removeChild(bundleBuilderOriginalDescription);
      }
    });
  }
})();

/**
 * Bundle Builder filter
 */
(function() {
  waitForElm("select.bundle-builder-app--bundle--filter--select").then(function(filterSelect) {
    const filterOptions = filterSelect.querySelectorAll("option");
    const desiredTags = [
      "Filter",
      "All Spices", 
      "Best Sellers",
      "New!",
      "Everyday Basics",
      "Blends",
      "Chilis & Paprikas",
      "Onions & Garlic",
      "Herbs",
      "Honey & Sugar",
      "Salt & Pepper"
    ];
  
    // Remove undesired options first
    filterOptions.forEach(function(option) {
      if (!desiredTags.includes(option.text)) {
        option.remove();
      }
    });
  
    // Reorder remaining options according to desiredTags
    const select = filterSelect;
    desiredTags.forEach(function(tag) {
      const option = Array.from(filterOptions).find(function(option) {
        return option.text === tag;
      });
      if (option) {
        if (tag === "Filter") {
          option.text = "All Spices";
          option.disabled = false;
        }
        select.append(option);
      }
    });
  });
})();

/**
 * Bundle Builder on-page search
 */
(function() {
  const clearIconHtml = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none"> <g clip-path="url(#clip0_169_17)"> <path d="M10.7406 9.50676L17.6027 2.65101C18.1022 2.15241 18.1022 1.40451 17.6027 0.90636C17.1036 0.40776 16.3548 0.40776 15.8558 0.90636L8.9937 7.76166L2.13165 0.90681C1.6326 0.40821 0.884249 0.40821 0.385199 0.90681C-0.114301 1.40541 -0.114301 2.15331 0.385199 2.65146L7.24725 9.50676L0.384749 16.3616C-0.113851 16.8602 -0.113851 17.6081 0.384749 18.1063C0.634499 18.3556 0.946349 18.4802 1.25865 18.4802C1.57095 18.4802 1.88235 18.3556 2.13165 18.1067L8.99415 11.2514L15.8558 18.1063C16.1055 18.3556 16.4174 18.4802 16.7292 18.4802C17.041 18.4802 17.3534 18.3556 17.6027 18.1067C18.1022 17.6077 18.1022 16.8602 17.6027 16.3616L10.7406 9.50676Z" fill="#3D4246"/> </g> <defs> <clipPath id="clip0_169_17"> <rect width="18" height="18" fill="white" transform="translate(0 0.5)"/> </clipPath> </defs> </svg>';
  
  function filterProducts(productList, searchValue) {
    const productNodes = productList.querySelectorAll('.bundle-builder-app--bundle--product');
  
    const noResultsNode = document.querySelector('#no-results');
    let noResults = true;
  
    productNodes.forEach((item) => {
      const title = item.querySelector('h3').innerText;
      if (title.toLowerCase().includes(searchValue.toLowerCase())) {
        item.classList.remove('hidden');
        noResultsNode.classList.add('hidden');
        noResults = false;
      } else {
        item.classList.add('hidden');
      }
    });
  
    if (noResults) {
      noResultsNode.textContent = `Sorry, nothing found for "${searchValue}".`;
      noResultsNode.classList.remove('hidden');
    }
  }
  const dFilterProducts = debounce(filterProducts);
  
  waitForElm('.bundle-builder-app--bundle--section--product-list').then(productList => {
  
    if (productList) {
      const wrapperNode = document.createElement('div');
      wrapperNode.classList.add('ca-burlap-007-search');
  
      const inputNode = document.createElement('input');
      inputNode.placeholder = 'Search for a spice to bundle';
  
      const noResultsNode = document.createElement('p');
      noResultsNode.id = 'no-results';
      noResultsNode.classList.add('hidden');
      productList.parentNode.append(noResultsNode);
  
      const handleInputChange = () => {
        const productList = document.querySelector('.bundle-builder-app--bundle--section--product-list');
  
        inputNode.className = `${inputNode.value.length > 0 && 'input-active'}`;
  
        dFilterProducts(productList, inputNode.value);
      };
  
      inputNode.addEventListener('input', handleInputChange);
      const searchIcon = document.querySelector('.js-show-search .icon')?.cloneNode(true);
      if (searchIcon) {
        searchIcon.classList.add('icon-search');
      }
  
      // + make handleInputChange a separate function
      // + append clear icon
      const clearIcon = document.createElement('button');
      clearIcon.innerHTML = clearIconHtml;
      clearIcon.classList.add('btn-clear');
      // + add click listener to clear icon:
      clearIcon.addEventListener('click', () => {
        inputNode.value = '';
        handleInputChange();
      });
      // + append btn
  
      wrapperNode.append(inputNode, searchIcon, clearIcon);
  
      const bundleFilterNode = document.querySelector('.bundle-builder-app--bundle--filter');
      bundleFilterNode.append(wrapperNode);
  
      const observer = new MutationObserver(() => {
        const productList = document.querySelector('.bundle-builder-app--bundle--section--product-list');
        dFilterProducts(productList, inputNode.value);
  
        const clearFilterBtn = document.querySelector('.bundle-builder-app--bundle--filter--clear-button');
        if (clearFilterBtn) {
          clearFilterBtn.addEventListener('click', () => {
            inputNode.value = '';
            dFilterProducts(productList, '');
          });
        }
      });
      observer.observe(document.querySelector('.bundle-builder-app--bundle--section--product-list'), {
        childList: true,
        subtree: true
      });
    }
  });
})();

/**
 * Bundle Builder product modal
 */
(function() {
  waitForElm('.bundle-builder-app--bundle--product--show-more').then(() => {
    const tagsToFilter = 'Get_Started, warning_msg, exclude_rebuy, Hidden, pre-order, Bundle, Single Spices, Everything Else, NoInvUpdate, gkt-gift-card(do not remove), norecipe, status:hidden, nocart, Pairs Well With: Hidden'.toLowerCase().split(', ');

    function createVariantIcon(name) {
      const map = {
        container: '//burlapandbarreoffers.com/cdn/shop/files/size_container_64x64.png?101232',
        grinder: '//burlapandbarreoffers.com/cdn/shop/files/size_grinder_64x64.png?101234',
        mini: '//burlapandbarreoffers.com/cdn/shop/files/size_mini_jar_64x64.png?101234',
        jar: '//burlapandbarreoffers.com/cdn/shop/files/size_jar_64x64.png?101232'
      };
      const icon = document.createElement('img');
      icon.className = 'variant--icon';
      if (name) {
        const key = Object.keys(map).find(k => name.toLowerCase().includes(k));
        if (key) icon.src = map[key];
      }
      return icon;
    }

    function enhanceThumbnailSlider(modalContent) {
      const thumbnailContainer = modalContent.querySelector('.bundle-builder-app--product-image-slider-thumbnails');
      if (!thumbnailContainer || thumbnailContainer.classList.contains('enhanced')) return;

      console.log('[BB Thumbnail Slider] Starting enhancement...');
      console.log('[BB Thumbnail Slider] Container:', thumbnailContainer);
      console.log('[BB Thumbnail Slider] Container styles:', {
        overflow: thumbnailContainer.style.overflow,
        position: thumbnailContainer.style.position,
        width: thumbnailContainer.style.width,
        height: thumbnailContainer.style.height
      });

      // Mark as enhanced to prevent double-processing
      thumbnailContainer.classList.add('enhanced');

      // Make thumbnails horizontally scrollable
      thumbnailContainer.style.overflowX = 'auto';
      thumbnailContainer.style.overflowY = 'hidden';
      thumbnailContainer.style.scrollBehavior = 'smooth';
      thumbnailContainer.style.scrollbarWidth = 'none'; // Firefox
      thumbnailContainer.style.msOverflowStyle = 'none'; // IE/Edge
      thumbnailContainer.style.display = 'flex';
      thumbnailContainer.style.flexWrap = 'nowrap';
      thumbnailContainer.style.gap = '8px';
      thumbnailContainer.style.padding = '0 8px';
      thumbnailContainer.style.width = '100%';
      thumbnailContainer.style.maxWidth = '100%';

      // Hide scrollbar for webkit browsers
      thumbnailContainer.style.setProperty('--webkit-scrollbar', 'none');

      // Ensure thumbnails are properly sized for slider
      const thumbnailItems = thumbnailContainer.querySelectorAll('li');
      console.log('[BB Thumbnail Slider] Found', thumbnailItems.length, 'thumbnails');
      
      thumbnailItems.forEach((item, index) => {
        // Remove any conflicting inline styles
        item.style.removeProperty('display');
        item.style.removeProperty('vertical-align');
        item.style.removeProperty('white-space');
        item.style.removeProperty('float');
        item.style.removeProperty('clear');
        item.style.removeProperty('margin');
        item.style.removeProperty('padding');
        
        // Force our styles
        item.style.display = 'flex';
        item.style.flexShrink = '0';
        item.style.flexGrow = '0';
        item.style.width = 'calc(22% - 6px)';
        item.style.minWidth = '70px';
        item.style.maxWidth = '100px';
        item.style.float = 'none';
        item.style.clear = 'none';
        item.style.margin = '0';
        item.style.padding = '0';
        
        console.log(`[BB Thumbnail Slider] Enhanced thumbnail ${index + 1}`);
      });

      // Add navigation buttons if there are many thumbnails
      if (thumbnailItems.length > 4) {
        console.log('[BB Thumbnail Slider] Adding navigation buttons...');
        
        // Create a wrapper div to contain the thumbnails and buttons
        const wrapper = document.createElement('div');
        wrapper.style.position = 'relative';
        wrapper.style.width = '100%';
        wrapper.style.display = 'flex';
        wrapper.style.alignItems = 'center';
        
        // Move the thumbnail container into the wrapper
        const parent = thumbnailContainer.parentNode;
        parent.insertBefore(wrapper, thumbnailContainer);
        wrapper.appendChild(thumbnailContainer);
        
        // Create prev button
        const prevBtn = document.createElement('button');
        prevBtn.type = 'button';
        prevBtn.className = 'slider-nav__btn tap-target btn has-ltr-icon';
        prevBtn.name = 'prev';
        prevBtn.setAttribute('aria-label', 'Previous thumbnails');
        
        // Add the icon
        const prevIcon = document.createElement('span');
        prevIcon.className = 'visually-hidden';
        prevIcon.textContent = 'Previous';
        prevBtn.appendChild(prevIcon);
        
        // Add the chevron icon
        const prevChevron = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        prevChevron.setAttribute('width', '24');
        prevChevron.setAttribute('height', '24');
        prevChevron.setAttribute('viewBox', '0 0 24 24');
        prevChevron.setAttribute('fill', 'currentColor');
        prevChevron.setAttribute('aria-hidden', 'true');
        prevChevron.setAttribute('focusable', 'false');
        prevChevron.setAttribute('role', 'presentation');
        prevChevron.className = 'icon';
        prevChevron.innerHTML = '<path d="m6.797 11.625 8.03-8.03 1.06 1.06-6.97 6.97 6.97 6.97-1.06 1.06z"/>';
        prevBtn.appendChild(prevChevron);
        
        // Create next button
        const nextBtn = document.createElement('button');
        nextBtn.type = 'button';
        nextBtn.className = 'slider-nav__btn tap-target btn has-ltr-icon';
        nextBtn.name = 'next';
        nextBtn.setAttribute('aria-label', 'Next thumbnails');
        
        // Add the icon
        const nextIcon = document.createElement('span');
        nextIcon.className = 'visually-hidden';
        nextIcon.textContent = 'Next';
        nextBtn.appendChild(nextIcon);
        
        // Add the chevron icon
        const nextChevron = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        nextChevron.setAttribute('width', '24');
        nextChevron.setAttribute('height', '24');
        nextChevron.setAttribute('viewBox', '0 0 24 24');
        nextChevron.setAttribute('aria-hidden', 'true');
        nextChevron.setAttribute('focusable', 'false');
        nextChevron.setAttribute('role', 'presentation');
        nextChevron.className = 'icon';
        nextChevron.innerHTML = '<path d="m9.693 4.5 7.5 7.5-7.5 7.5" stroke="currentColor" stroke-width="1.5" fill="none"/>';
        nextBtn.appendChild(nextChevron);

        // Position buttons relative to the wrapper (not the scrolling container)
        prevBtn.style.position = 'absolute';
        prevBtn.style.left = '-19px';
        prevBtn.style.top = 'calc(50% - 0.5rem)';
        prevBtn.style.transform = 'translateY(-50%)';
        prevBtn.style.zIndex = '1000';
        
        nextBtn.style.position = 'absolute';
        nextBtn.style.right = '-19px';
        nextBtn.style.top = 'calc(50% - 0.5rem)';
        nextBtn.style.transform = 'translateY(-50%)';
        nextBtn.style.zIndex = '1000';

        // Add click handlers
        prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          console.log('[BB Thumbnail Slider] Prev button clicked');
          thumbnailContainer.scrollBy({ left: -200, behavior: 'smooth' });
        });
        
        nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          console.log('[BB Thumbnail Slider] Next button clicked');
          thumbnailContainer.scrollBy({ left: 200, behavior: 'smooth' });
        });

        // Add buttons to the wrapper (not the scrolling container)
        wrapper.appendChild(prevBtn);
        wrapper.appendChild(nextBtn);
        
        console.log('[BB Thumbnail Slider] Navigation added to wrapper, buttons fixed');

        // Update button states based on scroll position
        const updateButtonStates = () => {
          const scrollLeft = thumbnailContainer.scrollLeft;
          const scrollWidth = thumbnailContainer.scrollWidth;
          const clientWidth = thumbnailContainer.clientWidth;
          
          // Add some tolerance for floating point precision
          const isAtStart = scrollLeft <= 1;
          const isAtEnd = scrollLeft >= (scrollWidth - clientWidth - 1);
          
          console.log('[BB Thumbnail Slider] Scroll state:', {
            scrollLeft,
            scrollWidth,
            clientWidth,
            scrollLeftMax: scrollWidth - clientWidth,
            isAtStart,
            isAtEnd,
            hasOverflow: scrollWidth > clientWidth
          });
          
          // Only disable buttons if there's actually overflow content
          const hasOverflow = scrollWidth > clientWidth;
          
          if (!hasOverflow) {
            // No overflow, enable both buttons
            prevBtn.disabled = false;
            nextBtn.disabled = false;
            console.log('[BB Thumbnail Slider] No overflow detected, enabling both buttons');
          } else {
            // Has overflow, manage button states
            if (isAtStart) {
              prevBtn.disabled = true;
              console.log('[BB Thumbnail Slider] At start, disabling prev button');
            } else {
              prevBtn.disabled = false;
              console.log('[BB Thumbnail Slider] Not at start, enabling prev button');
            }
            
            if (isAtEnd) {
              nextBtn.disabled = true;
              console.log('[BB Thumbnail Slider] At end, disabling next button');
            } else {
              nextBtn.disabled = false;
              console.log('[BB Thumbnail Slider] Not at end, enabling next button');
            }
          }
        };

        thumbnailContainer.addEventListener('scroll', updateButtonStates);
        
        // Initial state - wait a bit for DOM to settle
        setTimeout(() => {
          console.log('[BB Thumbnail Slider] Running initial button state check...');
          updateButtonStates();
        }, 100);
        
        console.log('[BB Thumbnail Slider] Navigation buttons added to wrapper, fixed positioning');
      }
      
      console.log('[BB Thumbnail Slider] Enhancement complete');
    }

    // Make product tiles open the modal when clicking anywhere on the tile
    document.querySelectorAll('.bundle-builder-app--bundle--product')
      .forEach((productTile) => {
        productTile.addEventListener('click', (e) => {
          if (e.target.closest('.bundle-builder-app--bundle--product-add--wrapper')
            || e.target.closest('.bundle-builder-app--bundle--product--show-more')) return;
          const btn = productTile.querySelector('.bundle-builder-app--bundle--product--show-more');
          if (btn) btn.click();
        }, true);
      });

    // Intercept show-more clicks to enhance modal content
    document.querySelectorAll('.bundle-builder-app--bundle--product--show-more')
      .forEach((btn) => {
        btn.addEventListener('click', (evt) => {
          const href = btn.href;
          if (!href) return;

          const productPromise = fetch(href + '.js')
            .then((response) => response.json());
          const shortDescriptionPromise = fetch(href + '?view=short-description')
            .then((response) => response.json())
            .then((data) => data['short_description']);

          waitForElm('.bundle-builder-app--product-modal--content').then((modalContent) => {
            const productNameEl = modalContent.querySelector('.bundle-builder-app--bundle--product-name');
            const variantNameEl = modalContent.querySelector('.bundle-builder-app--bundle--product--variant');
            const variantPriceEl = modalContent.querySelector('.bundle-builder-app--bundle--product-price');
            const atcWrapperEl = modalContent.querySelector('.bundle-builder-app--bundle--product-add--wrapper');
            const modalParent = modalContent.parentElement;

            // Price + variant wrapper
            const variantWrapper = document.createElement('div');
            variantWrapper.className = 'bundle-builder-app--bundle--product--variant--wrapper';
            variantWrapper.appendChild(createVariantIcon(variantNameEl?.textContent || ''));
            if (variantNameEl) variantWrapper.appendChild(variantNameEl);

            const priceVariantWrapper = document.createElement('div');
            priceVariantWrapper.className = 'bundle-builder-app--bundle--product--price-variant--wrapper';
            if (variantPriceEl) priceVariantWrapper.appendChild(variantPriceEl);
            priceVariantWrapper.appendChild(variantWrapper);

            if (productNameEl && productNameEl.parentNode) {
              productNameEl.insertAdjacentElement('afterend', priceVariantWrapper);
            }
            
            // Move the product options form to be between price-variant wrapper and add-to-cart wrapper
            const optionsForm = modalContent.querySelector('.bundle-builder-app--bundle--product-options-form');
            if (optionsForm) {
              // Remove the options form from its current position
              optionsForm.remove();
              // Insert it after the price-variant wrapper
              priceVariantWrapper.insertAdjacentElement('afterend', optionsForm);
              console.log('[BB Modal] Moved product options form between price and add-to-cart');

              // Convert variant selector(s) into a static "Label: Selected" line
              try {
                const optionGroups = optionsForm.querySelectorAll('.bundle-builder-app--bundle--product-options');
                optionGroups.forEach((group) => {
                  const labelEl = group.querySelector('label');
                  const selectEl = group.querySelector('select.bundle-builder-app--bundle--product-select');
                  if (!labelEl || !selectEl) return;

                  const selectedOption = (selectEl.selectedOptions && selectEl.selectedOptions[0]) || selectEl.options?.[selectEl.selectedIndex];
                  const selectedText = selectedOption ? selectedOption.textContent.trim() : '';
                  const labelText = labelEl.textContent.trim();

                  const staticRow = document.createElement('div');
                  staticRow.className = 'bundle-builder-app--bundle--product-option--static regular-text';
                  staticRow.innerHTML = `<p><strong>${labelText}</strong>${selectedText ? `: ${selectedText}</p>` : ''}`;

                  // Replace the group contents with the static row
                  group.innerHTML = '';
                  group.appendChild(staticRow);
                });
                console.log('[BB Modal] Converted product options to static display');
              } catch (err) {
                console.debug('[BB Modal] Failed converting options to static display', err);
              }
            }
            
            if (atcWrapperEl) {
              // Insert the add-to-cart wrapper after the options form (or after price wrapper if no options form)
              const insertAfterElement = optionsForm || priceVariantWrapper;
              insertAfterElement.insertAdjacentElement('afterend', atcWrapperEl);
            }

            // Short description
            shortDescriptionPromise.then((content) => {
              if (!content) return;
              const shortP = document.createElement('p');
              shortP.innerHTML = content;
              if (productNameEl) productNameEl.insertAdjacentElement('afterend', shortP);
              const onTransitionEnd = () => {
                if (!modalParent.classList.contains('bundle-builder-app--product-modal--backdrop--visible')) {
                  shortP.remove();
                  modalParent.removeEventListener('transitionend', onTransitionEnd);
                }
              };
              modalParent.addEventListener('transitionend', onTransitionEnd);
            });

            // Product data dependent UI (categories, images)
            productPromise.then((product) => {
              // Categories
              const productCategories = (product.tags || []).filter((raw) => {
                const tag = String(raw).toLowerCase();
                return !tag.includes('breadcrumb:')
                  && !tag.includes('status:')
                  && !tagsToFilter.includes(tag);
              });

              if (productCategories.length > 0) {
                // Check if categories section already exists
                let productCategoriesElement = modalContent.querySelector('.bundle-builder-app--bundle--product-categories');
                
                if (productCategoriesElement) {
                  // Update existing categories section
                  const ul = productCategoriesElement.querySelector('ul');
                  if (ul) {
                    // Clear existing list items
                    ul.innerHTML = '';
                    
                    // Add new categories
                    productCategories.forEach((category) => {
                      const li = document.createElement('li');
                      li.textContent = category;
                      ul.appendChild(li);
                    });
                    
                    // Add show more/less button if needed
                    if (productCategories.length > 5) {
                      const showMoreButton = document.createElement('li');
                      showMoreButton.className = 'bundle-builder-app--bundle--product-categories--show-more';
                      showMoreButton.textContent = 'Show More';
                      showMoreButton.addEventListener('click', () => {
                        productCategoriesElement.classList.toggle('show-all');
                        showMoreButton.textContent = productCategoriesElement.classList.contains('show-all') ? 'Show Less' : 'Show More';
                      });
                      ul.appendChild(showMoreButton);
                      productCategoriesElement.classList.remove('show-all');
                    } else {
                      productCategoriesElement.classList.add('show-all');
                    }
                  }
                } else {
                  // Create new categories section
                  productCategoriesElement = document.createElement('div');
                  productCategoriesElement.className = 'bundle-builder-app--bundle--product-categories';
                  const h5 = document.createElement('h5');
                  h5.textContent = 'Categories';
                  h5.classList.add('regular-text', 'mt-4');
                  const ul = document.createElement('ul');
                  
                  productCategories.forEach((category) => {
                    const li = document.createElement('li');
                    li.textContent = category;
                    ul.appendChild(li);
                  });
                  
                  if (productCategories.length > 5) {
                    const showMoreButton = document.createElement('li');
                    showMoreButton.className = 'bundle-builder-app--bundle--product-categories--show-more';
                    showMoreButton.textContent = 'Show More';
                    showMoreButton.addEventListener('click', () => {
                      productCategoriesElement.classList.toggle('show-all');
                      showMoreButton.textContent = productCategoriesElement.classList.contains('show-all') ? 'Show Less' : 'Show More';
                    });
                    ul.appendChild(showMoreButton);
                    productCategoriesElement.classList.remove('show-all');
                  } else {
                    productCategoriesElement.classList.add('show-all');
                  }
                  
                  productCategoriesElement.appendChild(h5);
                  productCategoriesElement.appendChild(ul);
                  
                  if (atcWrapperEl) atcWrapperEl.insertAdjacentElement('afterend', productCategoriesElement);
                }
              } else {
                // Remove categories section if no categories exist
                const existingCategories = modalContent.querySelector('.bundle-builder-app--bundle--product-categories');
                if (existingCategories) {
                  existingCategories.remove();
                }
              }   
            });

            // Enhance thumbnail slider after a short delay to ensure DOM is ready
            setTimeout(() => {
              enhanceThumbnailSlider(modalContent);
            }, 100);
          });
        });
      });
  });
})();

/**
 * Bundle Builder error message positioning and spice count link
 */
(function() {
  waitForElm('.bundle-builder-app--bundle--alert--content').then(elm => {

    // Make the ".bundle-builder-app--bundle--error-message" the last child in its parent

    const moveErrorToEnd = () => {
      const bundleError = elm.querySelector('.bundle-builder-app--bundle--error-message');
      if (bundleError && bundleError !== elm.lastElementChild) {
        const parent = bundleError.parentElement;
        bundleErrorObserver.disconnect();
        parent.appendChild(bundleError);
        bundleErrorObserver.observe(elm, {
          childList: true,
          subtree: true
        });
      }
    };

    const bundleErrorObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          for (let node of mutation.addedNodes) {
            if (node.classList && node.classList.contains('bundle-builder-app--bundle--error-message')) {
              moveErrorToEnd();
              break;
            }
          }
        }
      });
    });

    bundleErrorObserver.observe(elm, {
      childList: true,
      subtree: true
    });

    moveErrorToEnd();

    // Replace the count of spices with a link to the bundle summary

    const countSpanWrapper = elm.querySelector('.bundle-builder-app--number-of-products');
    const countSpan = countSpanWrapper.querySelector('span');
    const addLinkNextToCount = (nodeWithNumber) => {
      const matchedNumber = nodeWithNumber.textContent.match(/\d+/);
      if (!matchedNumber) return;
      const number = parseInt(matchedNumber[0]);
      const spiceText = number === 1 ? 'spice' : 'spices';

      // Hide the original span
      countSpan.style.display = 'none';

      // Check if the new span already exists
      let newSpan = countSpanWrapper.querySelector('.added-spice-count');

      if (!newSpan) {
        // Create the new span with the link if it doesn't exist
        newSpan = document.createElement('span');
        newSpan.className = 'added-spice-count';
        countSpanWrapper.appendChild(newSpan);
      }

      // Update the content of the new span
      const space = number >= 3 ? ' ' : '';
      if (number === 0) {
        newSpan.innerHTML = `You've added ${number} ${spiceText}.${space}`;
      } else {
        newSpan.innerHTML = `You've added <a href="#bundle-builder-app--summary">${number} ${spiceText}</a>.${space}`;
      }
    };

    const countSpanObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          addLinkNextToCount(mutation.addedNodes[0]);
        } else if (mutation.type === 'characterData') {
          addLinkNextToCount(countSpan);
        }
      });
    });

    countSpanObserver.observe(countSpan, {
      childList: true,
      subtree: true,
      characterData: true
    });

    addLinkNextToCount(countSpan);
  });
})();

/**
 * Change Bundle Builder's empty summary message
 */
(function() {
  waitForElm('.bundle-builder-app--bundle--summary--empty').then((elm) => {
    elm.innerHTML = '<span>You\'ve added 0 spices.</span><span>Get started by adding 3 spices!</span>';
  });
})();

/**
 * Persist Bundle Builder summary selections
 */
(function () {
  const STORAGE_KEY = 'bb_saved_items_v1';
  const getSavedItems = () => {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
  };
  const saveItems = (items) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch {
      console.warn('[BB Persist] Failed to save items', items);
    }
  };
  const collectAndSave = () => {
    const rows = document.querySelectorAll(
      '.bundle-builder-app--bundle--contents-list .bundle-builder-app--bundle--contents-item'
    );
    const items = Array.from(rows)
      .map((row) => {
        const nameEl = row.querySelector(
          '.bundle-builder-app--bundle--contents-name'
        );
        const qtyEl = row.querySelector(
          '.bundle-builder-app--bundle--contents-quantity'
        );
        if (!nameEl || !qtyEl) return null;
        return {
          name: nameEl.textContent.trim(),
          quantity: parseInt(qtyEl.textContent.trim(), 10) || 1,
        };
      })
      .filter(Boolean);

    if (items.length > 0) {
      saveItems(items);
      console.debug('[BB Persist] Saved', items);
    } else {
      // Ensure we clear out any stale saved items when list is empty
      try {
        localStorage.removeItem(STORAGE_KEY);
        console.debug('[BB Persist] No items found, cleared saved items');
      } catch {}
    }

    // saveItems(items);
    // console.debug('[BB Persist] Saved', items);
  };
  const attachObserver = () => {
    const summary = document.querySelector('.bundle-builder-app--bundle--summary');
    if (!summary) {
      console.debug('[BB Persist] Waiting for .bundle-builder-app--bundle--summary to exist');
      waitForElm('.bundle-builder-app--bundle--summary').then(attachObserver);
      return;
    }
    new MutationObserver(() => {
      collectAndSave();
    }).observe(summary, {
      childList: true,
      subtree: true,
      attributes: true,
      characterData: true,
    });
    collectAndSave();
    console.debug('[BB Persist] MutationObserver attached to summary container');
  };
  const clickTimes = (btn, times) => {
    for (let i = 0; i < times; i += 1) {
      btn?.click();
    }
  };
  const restoreItems = () => {
    const saved = getSavedItems();
    console.debug('[BB Persist] Loaded saved items', saved);
    if (!saved.length) return;
    saved.forEach(({ name, quantity }) => {
      console.debug('[BB Persist] Restoring', name, 'x', quantity);
      const [prodName, variantName] = name.split(' - ').map(s => s.trim());
      const card = Array.from(
        document.querySelectorAll('.bundle-builder-app--bundle--product')
      ).find(card => {
        const titleEl = card.querySelector('.bundle-builder-app--bundle--product-name');
        const variantEl = card.querySelector('.bundle-builder-app--bundle--product--variant');
        if (!titleEl) return false;

        const titleMatch = titleEl.textContent.trim() === prodName;

        // If we have a variant name, make sure it matches too
        if (variantName && variantEl) {
          return titleMatch && variantEl.textContent.trim() === variantName;
        }
        return titleMatch;
      })
      if (!card) {
        console.debug('[BB Persist] Card not found for', name);
        return;
      }
      const addBtn = card.querySelector(
        '.bundle-builder-app--bundle--product-add-button'
      );
      if (!addBtn) return;
      const plusBtn = card.querySelector('.bundle-builder-app--button--increase');
      const target = addBtn.classList.contains(
        'bundle-builder-app--bundle--product-add-button-added'
      )
        ? plusBtn || addBtn
        : addBtn;
      clickTimes(target, quantity);
    });
  };

  const init = () => {
    console.debug('[BB Persist] Initialising persistence logic');

    const ready = () => {
      restoreItems();
      attachObserver();
    };

    waitForElm('.bundle-builder-app--products').then(ready);
  };

  window.addEventListener("pageshow", () => {
    setTimeout(() => {
      init();
    }, 100);
  });
})();

/**
 * Handle Bundle Builder add-to-cart to open cart drawer, annotate bundle, and reset builder
 */
(function() {
  // Function to remove all products sequentially from bundle builder after adding to cart
  const removeSequentially = async () => {
    const getContents = () => {
      const list = document.querySelector('.bundle-builder-app--bundle--contents-list');
      return list ? [...list.children] : [];
    };

    const removeItem = async () => {
      // Always re-query a fresh remove button inside the list to avoid stale refs
      const listEl = document.querySelector('.bundle-builder-app--bundle--contents-list');
      if (!listEl) return false;
      const removeButton = listEl.querySelector('.bundle-builder-app--bundle--contents-remove-button');
      if (!removeButton) return false;

      await new Promise(resolve => {
        const observer = new MutationObserver(() => {
          const currentContents = getContents();
          if (currentContents.length < contents.length) {
            observer.disconnect();
            resolve();
          }
        });

        observer.observe(listEl, {
          childList: true,
          subtree: true
        });

        removeButton.click();
      });

      return true;
    };

    let contents = getContents();

    while (contents.length > 0) {
      const success = await removeItem();
      if (!success) break;
      contents = getContents();
    }
  };

  // Helper: open the theme cart drawer and refresh its contents
  function openCartDrawer() {
    try {
      // Proven event-based flow used by the theme
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
      // Issue a follow-up refresh to catch any async cart settling
      setTimeout(() => document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh')), 250);
      setTimeout(() => document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh')), 750);
    } catch (e) {
      // no-op
    }
  }

  // Read cart item_count with no-store to avoid caching
  async function getCartCount() {
    try {
      const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
        credentials: 'same-origin',
        cache: 'no-store'
      }).then(r => r.json());
      return cart?.item_count || 0;
    } catch {
      return 0;
    }
  }

  // Pre-render drawer sections (same call the theme makes) and open with content
  async function prerenderAndOpenDrawer() {
    const drawer = document.querySelector('cart-drawer');
    try {
      if (drawer && typeof drawer.getSectionsToRender === 'function' && typeof drawer.renderContents === 'function') {
        const sectionHandles = drawer.getSectionsToRender().map((s) => s.section);
        const res = await fetch(`?sections=${sectionHandles.join(',')}`, { cache: 'no-store' });
        const sections = await res.json();
        await drawer.renderContents({ sections }, true);
        // Safety follow-up refresh in case data changed between fetch and open
        setTimeout(() => document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh')), 200);
        return true;
      }
    } catch (e) {
      console.debug('[BB AfterAdd] prerenderAndOpenDrawer failed, falling back', e);
    }
    // Fallback to event-based flow
    openCartDrawer();
    return false;
  }

  // Helper: once the cart drawer is closed, scroll to top once
  function scrollOnDrawerCloseOnce() {
    try {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer) return;
      const observer = new MutationObserver(() => {
        // Drawer uses the "open" attribute when visible; when removed, it's closed
        const isOpen = drawer.getAttribute('open') !== null;
        if (!isOpen) {
          try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) {}
          observer.disconnect();
        }
      });
      observer.observe(drawer, { attributes: true, attributeFilter: ['open'] });
    } catch (e) {}
  }

  // Helper: annotate bundle component lines (not the parent) with private properties
  async function annotateBundleComponents() {
    try {
      console.debug('[BB AfterAdd] Starting component annotation');

      // Helper to get components via our Liquid JSON view
      const fetchComponents = async () => {
        try {
          const url = `${window.Shopify?.routes?.root || '/'}cart?view=components`;
          const res = await fetch(url, { cache: 'no-store', credentials: 'same-origin' });
          return await res.json();
        } catch (e) {
          return null;
        }
      };
      const compJson = await fetchComponents();
      const items = Array.isArray(compJson?.items) ? compJson.items : [];
      const parents = items
        .filter(it => Array.isArray(it?.components) && it.components.length > 0)
        .sort((a, b) => String(a?.key || '').localeCompare(String(b?.key || ''))); // stable bundle numbering

      // Build per-component entries (not per-unit) and compute total units per bundle
      const totalsByBundle = {};
      const allQty1ByBundle = {};
      parents.forEach((parent, pIdx) => {
        const idx = pIdx + 1;
        let sum = 0;
        let all1 = true;
        (parent.components || []).forEach((c) => { const q = (c?.quantity || 1); sum += q; if (q !== 1) all1 = false; });
        totalsByBundle[idx] = sum;
        allQty1ByBundle[idx] = all1;
      });

      const entries = [];
      parents.forEach((parent, pIdx) => {
        const idx = pIdx + 1;
        (parent.components || []).forEach((c, compIdx) => {
          entries.push({
            bundleIndex: idx,
            position: compIdx + 1,
            key: c?.key,
            variant_id: c?.variant_id,
            quantity: c?.quantity || 1,
            title: c?.title || c?.product_title || '',
            properties: Object.assign({}, c?.properties || {})
          });
        });
      });

      if (!entries.length) {
        console.debug('[BB AfterAdd] No components available for annotation.');
        return;
      }

      // Simple sequential updates to avoid contention and simplify debugging
      let success = 0;
      let failures = 0;

      // (no ordinals needed)

      const unitCursorByBundle = {};
      const runOne = async (entry) => {
        const bundleIndex = entry.bundleIndex || 1;
        const total = totalsByBundle[bundleIndex] || entry.quantity || 1;
        const qty = entry.quantity || 1;
        const pos = entry.position || 1;
        const all1 = !!allQty1ByBundle[bundleIndex];
        let label;
        if (all1) {
          // No duplicate quantities: show simple position of total
          label = `Bundle ${bundleIndex} (${pos} of ${total} spices)`;
        } else {
          // Mixed or duplicate quantities: show unit range for qty>1, or unit position for qty==1
          const start = (unitCursorByBundle[bundleIndex] || 1);
          const end = start + qty - 1;
          if (qty > 1) {
            label = `Bundle ${bundleIndex} (${start}-${end} of ${total} spices)`;
          } else {
            label = `Bundle ${bundleIndex} (${start} of ${total} spices)`;
          }
          unitCursorByBundle[bundleIndex] = end + 1;
        }

        // Merge with existing component properties from the view; avoid overwriting
        const properties = Object.assign({}, entry.properties || {}, { _bb_bundle_label: label });

        // Attempt by key; fallback to line index if key moved
        const tryAnnotate = async () => {
          // By key
          let res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ id: entry.key, properties })
          });
          if (res.ok) return true;

          // Fallback: best-effort by line index if visible in /cart.js
          try {
            const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { credentials: 'same-origin', cache: 'no-store' }).then(r => r.json());
            const idx = Array.isArray(cart?.items) ? cart.items.findIndex(li => li?.key === entry.key) : -1;
            if (idx !== -1) {
              res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify({ line: idx + 1, properties })
              });
              if (res.ok) return true;
            }
          } catch {}
          return false;
        };
        const ok = await tryAnnotate();
        if (ok) success += 1; else failures += 1;
        // small pause to reduce contention
        await new Promise(r => setTimeout(r, 60));
      };

      // Run sequentially
      for (const entry of entries) {
        await runOne(entry);
      }

      console.debug('[BB AfterAdd] Annotation complete', { success, failures, totalEntries: entries.length });

      if (success === 0) {
        console.debug('[BB AfterAdd] No components annotated. It is possible components are not exposed in /cart.js.');
      }
    } catch (e) {
      console.debug('[BB AfterAdd] Unexpected error while annotating components', e);
    }
  }

  // Public hook exposed by the Bundle Builder app after add-to-cart
  window.bbAfterAddToCart = async function() {
    // Open the drawer only after sections are fetched so we avoid empty-state flash
    await prerenderAndOpenDrawer();
    // Remember to scroll to top once the drawer is closed
    scrollOnDrawerCloseOnce();

    // Annotate components (after cart has changed so lines exist)
    try {
      await annotateBundleComponents();
    } catch (e) {
      console.debug('[BB AfterAdd] annotateBundleComponents threw', e);
    }

    // Reset Bundle Builder persistence and clean up the builder UI
    try { await removeSequentially(); } catch (e) { console.debug('[BB AfterAdd] removeSequentially error', e); }
    try { localStorage.removeItem('bb_saved_items_v1'); } catch (e) { console.debug('[BB AfterAdd] localStorage remove error', e); }

    // Scroll to the top for a clean state
    // Defer scroll to close handler above; no-op here

    // Prevent default redirection behavior in the app (if supported)
    return false;
  };
})();

/**
 * Bundle builder summary new UI
 */

function renderNewSummary()
{
    if (!document.querySelector(".bundle-builder-app--bundle--summary"))
    {
        setTimeout(renderNewSummary, 30);
        return ;
    }

    let saved_state = {products: {}};
    let summary_space = document.querySelector(".bundle-builder-app--bundle--summary");
    let summary_observer = new MutationObserver(update_bundle_state);
    summary_observer.observe(summary_space, { childList: true, subtree: true, characterData: true, attributeFilter: ["disabled"] });
    let did_atc = false;

    function add_to_cart()
    {
        let button = document.querySelector(".bundle-builder-app--bundle--summary > div > div.bundle-builder-app--button-container > button.bundle-builder-app--button");

        if (button)
        {
          button.click();
          did_atc = true;
        }
    }

    function remove_item(event)
    {
        let products = document.querySelectorAll(".bundle-builder-app--bundle--summary > div > .bundle-builder-app--bundle--contents > ul.bundle-builder-app--bundle--contents-list > li");
        let title = event.currentTarget.parentElement.querySelector("div.info > b").textContent;

        for (let i = 0; i < products.length; i++)
            if (products[i].querySelector("div > h3").textContent.split(" - ")[0] === title)
            {
                products[i].querySelector("div > div.bundle-builder-app--bundle--contents--quantity > button.bundle-builder-app--bundle--contents-subtract").click();
                break ;
            }
    }
    
    function update_bundle_state()
    {
        let state = {price: "$0", dashed_price: "", discount: "Congrats! You've got $1.00 discount.", button_disabled: true, products: {}, count: 0};
        let products = summary_space.querySelectorAll(":scope > div > div.bundle-builder-app--bundle--contents > ul.bundle-builder-app--bundle--contents-list > li.bundle-builder-app--bundle--contents-item");

        if (summary_space.querySelector(":scope > div"))
        {
            state.price = summary_space.querySelector(":scope > div > span.bundle-builder-app--bundle--price-box > div.bundle-builder-app--bundle--price > span.bundle-builder-app--bundle--total-price > span.money")?.textContent;
            state.dashed_price = summary_space.querySelector(":scope > div > span.bundle-builder-app--bundle--price-box > div.bundle-builder-app--bundle--price > span.bundle-builder-app--bundle--original-price > span.money")?.textContent;
            state.discount = summary_space.querySelector(":scope > div > div.bundle-builder-app--bundle--discount-summary > span > span")?.textContent;
            state.button_disabled = summary_space.querySelector(":scope > div > div.bundle-builder-app--button-container > button.bundle-builder-app--button")?.hasAttribute("disabled");
            
            for (let i = 0; i < products.length; i++)
            {
                let title = products[i].querySelector("div > h3").textContent.split(" - ")[0];

                state.products[title] = {};
                state.products[title].jar = products[i].querySelector("div > h3").textContent.split(" - ")[1];
                state.products[title].quantity = +products[i].querySelector("div > div.bundle-builder-app--bundle--contents--quantity > span.bundle-builder-app--bundle--contents-quantity").textContent;
                state.products[title].src = products[i].querySelector("div > img").src;
                state.products[title].srcset = products[i].querySelector("div > img").srcset;

                state.count += state.products[title].quantity;
            }
        }

        render_state(saved_state, state);
        mobile_render_state(saved_state, state);

        saved_state = state;
    }

    function render_state(old_state, new_state)
    {
        let     copied_old_state = JSON.parse(JSON.stringify(old_state));
        let     copied_new_state = JSON.parse(JSON.stringify(new_state));
        const   products_space = document.querySelector("div.new_bundle_summary > section.products_space");

        if (old_state.price != new_state.price)
            document.querySelector("div.new_bundle_summary > section.summary > b > span.price").textContent = new_state.price;
        if (old_state.dashed_price != new_state.dashed_price)
            document.querySelector("div.new_bundle_summary > section.summary > b > span.dashed").textContent = new_state.dashed_price;
        if (old_state.count != new_state.count)
        {
            if (did_atc && new_state.count === 0)
            {
              did_atc = false;
              mobile_summary_opener({currentTarget: document.querySelector("div.new_mobile_bundle_summary > section.products_space > header > svg")});
            }

            if (new_state.count > 0)
                document.querySelector("div.new_bundle_summary > section.products_space > strong").classList.remove("hidden");
            else
                document.querySelector("div.new_bundle_summary > section.products_space > strong").classList.add("hidden");

            switch (new_state.count)
            {
                case 1:
                case 2:
                    document.querySelector("div.new_bundle_summary > section.products_space > strong > span.primary").innerHTML = `Add ${3 - new_state.count} more spices for <strong>$1</strong> discount.`;
                    break;
                case 3:
                    document.querySelector("div.new_bundle_summary > section.products_space > strong > span.primary").innerHTML = `You got <strong>$1</strong> off! Add 3 more spices to save <strong>$3</strong>.`;
                    break;
                case 4:
                case 5:
                    document.querySelector("div.new_bundle_summary > section.products_space > strong > span.primary").innerHTML = `Add ${6 - new_state.count} more spices for <strong>$3</strong> off.`;
                    break;
                case 6:
                    document.querySelector("div.new_bundle_summary > section.products_space > strong > span.primary").innerHTML = `You got <strong>$3</strong> off! Add 3 more spices to save <strong>$5</strong>.`;
                    break;
                case 7:
                case 8:
                    document.querySelector("div.new_bundle_summary > section.products_space > strong > span.primary").innerHTML = `Add ${9 - new_state.count} more spices for <strong>$5</strong> off.`;
                    break;
                case 9:
                    document.querySelector("div.new_bundle_summary > section.products_space > strong > span.primary").innerHTML = `You got <strong>$5</strong> off! Add 3 more spices to save <strong>$8</strong>.`;
                    break;
                case 10:
                case 11:
                    document.querySelector("div.new_bundle_summary > section.products_space > strong > span.primary").innerHTML = `Add ${12 - new_state.count} more spices for <strong>$8</strong> off.`;
                    break;
                case 12:
                default:
                    document.querySelector("div.new_bundle_summary > section.products_space > strong > span.primary").innerHTML = `You got <strong>$8</strong> off!`;
                    break;
            }
        }
        if (old_state.button_disabled != new_state.button_disabled)
        {
            if (!new_state.button_disabled)
                document.querySelector("div.new_bundle_summary > section.summary > button").removeAttribute("disabled");
            else
                document.querySelector("div.new_bundle_summary > section.summary > button").setAttribute("disabled", "");
        }

        if (!Object.keys(new_state.products).length)
        {
            document.querySelector("div.new_bundle_summary > section.products_space > span.empty").style.display = "block";
            document.querySelector("div.new_bundle_summary > section.products_space > strong").classList.add("removed");
        }
        else
        {
            document.querySelector("div.new_bundle_summary > section.products_space > span.empty").style.display = "";
            document.querySelector("div.new_bundle_summary > section.products_space > strong").classList.remove("removed");
        }

        for (product_title in copied_old_state.products)
        {
            if (copied_new_state.products[product_title])
            {
                if (copied_old_state.products[product_title].quantity < copied_new_state.products[product_title].quantity)
                    for (let i = 0, n = copied_new_state.products[product_title].quantity - copied_old_state.products[product_title].quantity; i < n; i++)
                    {
                        products_space.insertAdjacentHTML("beforeend", `   <div class="product">
                                                                                <div class="img_wrapper">
                                                                                    <img srcset="${copied_new_state.products[product_title].srcset}" src="${copied_new_state.products[product_title].src}"/>
                                                                                </div>
                                                                                <div class="info">
                                                                                    <b>${product_title}</b>
                                                                                    <p>${copied_new_state.products[product_title].jar || ""}</p>
                                                                                </div>
                                                                                <span class="close_button">
                                                                                  <svg width="20" height="20" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation" class="icon" data--h-bstatus="0OBSERVED">
                                                                                    <path d="M14 3h-3.53a3.07 3.07 0 0 0-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 0 0 5.53 3H2a.5.5 0 0 0 0 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 0 0 .5-.5V4H14a.5.5 0 0 0 0-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor" data--h-bstatus="0OBSERVED"></path><path d="M6.55 5.25a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5zm2.9 0a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5z" fill="currentColor" data--h-bstatus="0OBSERVED"></path>
                                                                                  </svg>
                                                                                </span>
                                                                            </div>`);
                        
                        products_space.lastChild.querySelector("span.close_button").onclick = remove_item;
                    }
                else if (copied_old_state.products[product_title].quantity > copied_new_state.products[product_title].quantity)
                {
                    let n = copied_old_state.products[product_title].quantity - copied_new_state.products[product_title].quantity;
                    
                    for (let products = products_space.querySelectorAll("div.product"), i = products.length - 1, m = 0; i >= 0; i--)
                    {
                        if (products[i].querySelector("div.info > b").textContent === product_title)
                        {
                            products[i].remove();
                            m++;
                            if (m === n)
                                break ;
                        }
                    }
                }

                delete copied_old_state.products[product_title];
                delete copied_new_state.products[product_title];
            }
            else
            {
                for (let products = products_space.querySelectorAll("div.product"), i = products.length - 1; i >= 0; i--)
                    if (products[i].querySelector("div.info > b").textContent === product_title)
                        products[i].remove();
            }
        }

        for (product_title in copied_new_state.products)
        {
            for (let i = 0; i < copied_new_state.products[product_title].quantity; i++)
            {
                products_space.insertAdjacentHTML("beforeend", `   <div class="product">
                                                                        <div class="img_wrapper">
                                                                            <img srcset="${copied_new_state.products[product_title].srcset}" src="${copied_new_state.products[product_title].src}"/>
                                                                        </div>
                                                                        <div class="info">
                                                                            <b>${product_title}</b>
                                                                            <p>${copied_new_state.products[product_title].jar || ""}</p>
                                                                        </div>
                                                                        <span class="close_button">
                                                                          <svg width="20" height="20" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation" class="icon" data--h-bstatus="0OBSERVED">
                                                                            <path d="M14 3h-3.53a3.07 3.07 0 0 0-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 0 0 5.53 3H2a.5.5 0 0 0 0 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 0 0 .5-.5V4H14a.5.5 0 0 0 0-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor" data--h-bstatus="0OBSERVED"></path><path d="M6.55 5.25a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5zm2.9 0a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5z" fill="currentColor" data--h-bstatus="0OBSERVED"></path>
                                                                          </svg>
                                                                        </span>
                                                                    </div>`);
                
                products_space.lastChild.querySelector("span.close_button").onclick = remove_item;
            }
        }
    }

    function mobile_render_state(old_state, new_state)
    {
        let     copied_old_state = JSON.parse(JSON.stringify(old_state));
        let     copied_new_state = JSON.parse(JSON.stringify(new_state));
        const   products_space = document.querySelector("div.new_mobile_bundle_summary > section.products_space");
        let     current_products_count = 0;

        if (old_state.price != new_state.price)
            document.querySelector("div.new_mobile_bundle_summary > section.summary > b > span.price").textContent = new_state.price;
        if (old_state.dashed_price != new_state.dashed_price)
            document.querySelector("div.new_mobile_bundle_summary > section.summary > b > span.dashed").textContent = new_state.dashed_price;
        if (old_state.count != new_state.count)
        {
            if (new_state.count > 0)
                document.querySelector("div.new_mobile_bundle_summary > section.products_space > strong").classList.remove("hidden");
            else
                document.querySelector("div.new_mobile_bundle_summary > section.products_space > strong").classList.add("hidden");

            switch (new_state.count)
            {
                case 1:
                case 2:
                    document.querySelector("div.new_mobile_bundle_summary > section.products_space > strong > span.primary").innerHTML = `Add ${3 - new_state.count} more spices for <strong>$1</strong> discount.`;
                    break;
                case 3:
                    document.querySelector("div.new_mobile_bundle_summary > section.products_space > strong > span.primary").innerHTML = `You got <strong>$1</strong> off! Add 3 more spices to save <strong>$3</strong>.`;
                    break;
                case 4:
                case 5:
                    document.querySelector("div.new_mobile_bundle_summary > section.products_space > strong > span.primary").innerHTML = `Add ${6 - new_state.count} more spices for <strong>$3</strong> off.`;
                    break;
                case 6:
                    document.querySelector("div.new_mobile_bundle_summary > section.products_space > strong > span.primary").innerHTML = `You got <strong>$3</strong> off! Add 3 more spices to save <strong>$5</strong>.`;
                    break;
                case 7:
                case 8:
                    document.querySelector("div.new_mobile_bundle_summary > section.products_space > strong > span.primary").innerHTML = `Add ${9 - new_state.count} more spices for <strong>$5</strong> off.`;
                    break;
                case 9:
                    document.querySelector("div.new_mobile_bundle_summary > section.products_space > strong > span.primary").innerHTML = `You got <strong>$5</strong> off! Add 3 more spices to save <strong>$8</strong>.`;
                    break;
                case 10:
                case 11:
                    document.querySelector("div.new_mobile_bundle_summary > section.products_space > strong > span.primary").innerHTML = `Add ${12 - new_state.count} more spices for <strong>$8</strong> off.`;
                    break;
                case 12:
                default:
                    document.querySelector("div.new_mobile_bundle_summary > section.products_space > strong > span.primary").innerHTML = `You got <strong>$8</strong> off!`;
                    break;
            }
        }
        if (old_state.button_disabled != new_state.button_disabled)
        {
            if (!new_state.button_disabled)
                document.querySelector("div.new_mobile_bundle_summary > section.summary > button").removeAttribute("disabled");
            else
                document.querySelector("div.new_mobile_bundle_summary > section.summary > button").setAttribute("disabled", "");
        }

        if (!Object.keys(new_state.products).length)
        {
            document.querySelector("div.new_mobile_bundle_summary > section.products_space > span.empty").style.display = "block";
            document.querySelector("div.new_mobile_bundle_summary > section.products_space > strong").classList.add("removed");
        }
        else
        {
            document.querySelector("div.new_mobile_bundle_summary > section.products_space > span.empty").style.display = "";
            document.querySelector("div.new_mobile_bundle_summary > section.products_space > strong").classList.remove("removed");
        }

        for (product in new_state.products)
        {
            current_products_count += new_state.products[product].quantity;
        }

        if (new_state.count > 0)
          document.querySelector("div.new_mobile_bundle_summary > section.products_space > header > p").innerHTML = document.querySelector("div.new_mobile_bundle_summary > section.products_space > strong > span.primary").innerHTML;
        else
          document.querySelector("div.new_mobile_bundle_summary > section.products_space > header > p").innerHTML = "Nothing here yet! Start adding spices.";

        for (product_title in copied_old_state.products)
        {
            if (copied_new_state.products[product_title])
            {
                if (copied_old_state.products[product_title].quantity < copied_new_state.products[product_title].quantity)
                    for (let i = 0, n = copied_new_state.products[product_title].quantity - copied_old_state.products[product_title].quantity; i < n; i++)
                    {
                        products_space.insertAdjacentHTML("beforeend", `   <div class="product">
                                                                                <div class="img_wrapper">
                                                                                    <img srcset="${copied_new_state.products[product_title].srcset}" src="${copied_new_state.products[product_title].src}"/>
                                                                                </div>
                                                                                <div class="info">
                                                                                    <b>${product_title}</b>
                                                                                    <p>${copied_new_state.products[product_title].jar || ""}</p>
                                                                                </div>
                                                                                <span class="close_button">
                                                                                  <svg width="20" height="20" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation" class="icon" data--h-bstatus="0OBSERVED">
                                                                                    <path d="M14 3h-3.53a3.07 3.07 0 0 0-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 0 0 5.53 3H2a.5.5 0 0 0 0 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 0 0 .5-.5V4H14a.5.5 0 0 0 0-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor" data--h-bstatus="0OBSERVED"></path><path d="M6.55 5.25a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5zm2.9 0a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5z" fill="currentColor" data--h-bstatus="0OBSERVED"></path>
                                                                                  </svg>
                                                                                </span>
                                                                            </div>`);
                        
                        products_space.lastChild.querySelector("span.close_button").onclick = remove_item;
                    }
                else if (copied_old_state.products[product_title].quantity > copied_new_state.products[product_title].quantity)
                {
                    let n = copied_old_state.products[product_title].quantity - copied_new_state.products[product_title].quantity;
                    
                    for (let products = products_space.querySelectorAll("div.product"), i = products.length - 1, m = 0; i >= 0; i--)
                    {
                        if (products[i].querySelector("div.info > b").textContent === product_title)
                        {
                            products[i].remove();
                            m++;
                            if (m === n)
                                break ;
                        }
                    }
                }

                delete copied_old_state.products[product_title];
                delete copied_new_state.products[product_title];
            }
            else
            {
                for (let products = products_space.querySelectorAll("div.product"), i = products.length - 1; i >= 0; i--)
                    if (products[i].querySelector("div.info > b").textContent === product_title)
                        products[i].remove();
            }
        }

        for (product_title in copied_new_state.products)
        {
            for (let i = 0; i < copied_new_state.products[product_title].quantity; i++)
            {
                products_space.insertAdjacentHTML("beforeend", `   <div class="product">
                                                                        <div class="img_wrapper">
                                                                            <img srcset="${copied_new_state.products[product_title].srcset}" src="${copied_new_state.products[product_title].src}"/>
                                                                        </div>
                                                                        <div class="info">
                                                                            <b>${product_title}</b>
                                                                            <p>${copied_new_state.products[product_title].jar || ""}</p>
                                                                        </div>
                                                                        <span class="close_button">
                                                                          <svg width="20" height="20" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation" class="icon" data--h-bstatus="0OBSERVED">
                                                                            <path d="M14 3h-3.53a3.07 3.07 0 0 0-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 0 0 5.53 3H2a.5.5 0 0 0 0 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 0 0 .5-.5V4H14a.5.5 0 0 0 0-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor" data--h-bstatus="0OBSERVED"></path><path d="M6.55 5.25a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5zm2.9 0a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5z" fill="currentColor" data--h-bstatus="0OBSERVED"></path>
                                                                          </svg>
                                                                        </span>
                                                                    </div>`);
                
                products_space.lastChild.querySelector("span.close_button").onclick = remove_item;
            }
        }

        saved_state = new_state;
    }

    const   newSummaryHtml = `  <div class="new_bundle_summary">
                                    <section class="products_space">
                                        <strong class="hidden">
                                            <span class="primary">Congrats! You've got a $1.00 discount.</span>
                                            <span class="secondary">Add at least 3 spices.</span>
                                        </strong>
                                        <span class="empty">Nothing here yet! Start adding spices.</span>
                                    </section>
                                    <section class="summary">
                                        <b>Bundle Price: <span class="dashed"></span> <span class="price"></span></b>
                                        <button>Add To Cart</button>
                                    </section>
                                </div>`;
    const   mobileSummaryHtml = `  <div class="new_mobile_bundle_summary">
                                    <section class="products_space">
                                        <header>
                                            <p>Nothing here yet! Start adding spices.</span></p>
                                            <button>Review Your Bundle</button>
                                            <svg version="1.0" width="20px" height="20px" viewBox="0 0 512.000000 512.000000"  preserveAspectRatio="xMidYMid meet">
                                                <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                                                fill="#565a5d" stroke="none">
                                                    <path d="M2490 4381 c-53 -17 -110 -52 -140 -88 -100 -122 -2327 -3156 -2337
                                                    -3184 -7 -20 -13 -67 -13 -105 0 -55 5 -81 26 -122 77 -154 291 -199 420 -88
                                                    23 19 506 665 1074 1436 569 770 1037 1400 1040 1400 4 0 471 -630 1040 -1400
                                                    568 -771 1051 -1417 1074 -1436 129 -111 343 -66 420 88 21 42 26 66 26 125 0
                                                    41 -6 89 -14 108 -21 48 -2309 3152 -2361 3201 -65 61 -175 89 -255 65z"/>
                                                </g>
                                            </svg>

                                        </header>
                                        <strong class="hidden">
                                            <span class="primary">Congrats! You've got a $1.00 discount.</span>
                                            <span class="secondary">Add at least 3 spices.</span>
                                        </strong>
                                        <span class="empty">Nothing here yet! Start adding spices.</span>
                                    </section>
                                    <section class="summary">
                                        <b>Bundle Price: <span class="dashed"></span> <span class="price"></span></b>
                                        <button>Add To Cart</button>
                                    </section>
                                </div>`;

    document.querySelector(".bundle-builder-app--bundle--summary").style.display = "none";
    // document.querySelector("div.bundle-builder-app--bundle--alert").style.display = "none";
    
    function mobile_summary_opener(event)
    {
        if (event.currentTarget.parentElement.parentElement.parentElement.parentElement.classList.contains("open"))
        {
            event.currentTarget.parentElement.parentElement.parentElement.parentElement.classList.remove("open");
            document.querySelector("div.closing_space").remove();
            document.querySelector(".bundle-builder-app--bundle--alert > div.new_mobile_bundle_summary > section.products_space").scrollTop = 0;
        }
        else
        {
            event.currentTarget.parentElement.parentElement.parentElement.parentElement.classList.add("open");
            document.body.insertAdjacentHTML("beforeend", ` <div class="closing_space"></div>`);
            document.querySelector("div.closing_space").onclick = () => {document.querySelector(".bundle-builder-app--bundle--alert > div.new_mobile_bundle_summary > section.products_space > header > button").click()};
        }
    }

    
    document.querySelector(".bundle-builder-app--summary--block").insertAdjacentHTML("beforeend", newSummaryHtml);
    document.querySelector("div.new_bundle_summary > section.summary > button").onclick = add_to_cart;
    function insert_mobile_summary()
    {
        if (document.querySelector(".bundle-builder-app--bundle--alert"))
        {
            document.querySelector(".bundle-builder-app--bundle--alert").insertAdjacentHTML("afterbegin", mobileSummaryHtml);
            document.querySelector(".bundle-builder-app--bundle--alert > div.new_mobile_bundle_summary > section.products_space > header > button").onclick = mobile_summary_opener;
            document.querySelector(".bundle-builder-app--bundle--alert > div.new_mobile_bundle_summary > section.products_space > header > svg").onclick = mobile_summary_opener;
            document.querySelector(".bundle-builder-app--bundle--alert > div.new_mobile_bundle_summary > section.summary > button").onclick = add_to_cart;
            update_bundle_state();
        }
        else
            setTimeout(() => {
                insert_mobile_summary();
            }, 10);
    }

    function alter_chat_button_place()
    {
        if (document.querySelector("iframe[title='Gorgias live chat messenger']"))
        {
            document.querySelector("iframe[title='Gorgias live chat messenger']").style.right = "revert";
            document.querySelector("iframe[title='Gorgias live chat messenger']").style.left = "20px";
        }
        else
            setTimeout(() => {
                alter_chat_button_place();
            }, 10);
    }
    
    insert_mobile_summary();
    alter_chat_button_place();
}

renderNewSummary();